export const isValidUrl = (urlCandidate: string) => {
  try {
    new URL(urlCandidate);
    return true;
  } catch (err) {
    return false;
  }
};
